import { ImgHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

import { baseRoute } from '@/config';
import { isWebpSupport } from '@/utils/image';

import logo01compat from './assets/logo01.png';
import logo01 from './assets/logo01.webp';
import logo02compat from './assets/logo02.png';
import logo02 from './assets/logo02.webp';

export type LogoProps = {
  className?: string;
  disableLink?: boolean;
  afterLinking?: () => void;
  type?: '01' | '02';
  imageProps?: ImgHTMLAttributes<HTMLImageElement>;
};

export const Logo = ({
  className = '',
  afterLinking,
  disableLink = false,
  type = '01',
  imageProps,
}: LogoProps) => {
  const LogoImg = () => (
    <img
      className={className}
      src={
        type === '01'
          ? isWebpSupport
            ? logo01
            : logo01compat
          : isWebpSupport
          ? logo02
          : logo02compat
      }
      alt="logo"
      {...imageProps}
    />
  );
  if (disableLink) return <LogoImg />;
  return (
    <Link
      to={baseRoute}
      onClick={() => {
        afterLinking && afterLinking();
      }}
      className="transition duration-500 hover:opacity-80"
    >
      <LogoImg />
    </Link>
  );
};
